import { formatDate, getCurrentDate } from "@taabl/common-lib/calculators/date";
import { Form, Formik } from "formik";
import moment from "moment";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import FormikDateField from "../../components/Forms/FormikDateField";
import FormikDropdown from "../../components/Forms/FormikDropdown";
import LoaderButton from "../../components/LoaderButton";
import PageLoader from "../../components/PageLoader";
import ViewFileURL from "../../components/ViewFileURL";
import LoggedInLayout from "../../layouts/loggedinlayout";
import { Constants } from "../../libs/Constants";
import { getList } from "../../libs/dbFunctions";
import Events from "./Events";
import ExportEvents from "./ExportEvents";
const initialValues = {
  filterBy: "date",
  startDate: getCurrentDate(false)
    .subtract(30, "days")
    .format(Constants.DATEFORMAT.MMDDYYYY),
  endDate: getCurrentDate(false).format(Constants.DATEFORMAT.MMDDYYYY),
  eventType: "",
};
const schema = yup.object({
  filterBy: yup.string().required("You are required to select search type"),
  startDate: yup.date().test("startDate", function(value) {
    if (this.parent.filterBy === "date" && !value) {
      return this.createError({
        message: "Select Start date ",
        path: "startDate",
      });
    }
    return true;
  }),
  endDate: yup.date().test("endDate", function(value) {
    if (this.parent.filterBy === "date" && !value) {
      return this.createError({
        message: "Select End date ",
        path: "endDate",
      });
    }
    return true;
  }),
  eventType: yup.string().test("eventType", function(value) {
    if (this.parent.filterBy === "type" && !value) {
      return this.createError({
        message: "Select Event Name ",
        path: "eventType",
      });
    }
    return true;
  }),
});

const SignupEvents = ({ activeCompany }) => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = React.useState([]);
  const [eventTypes, setEventTypes] = React.useState([]);
  React.useEffect(() => {
    loadEventTypes();
    // Load initial date filters
    onSubmit(initialValues);
  }, []);
  async function loadEventTypes() {
    try {
      let response = await getList(
        "event_types",
        activeCompany,
        {},
        "events-api"
      );
      if (response) {
        setEventTypes(
          response.map((r) => {
            return {
              id: r.event_order,
              value: r.name,
              name: r.display_name,
              payload: r,
            };
          })
        );
      }
    } catch (err) {
      toast.error("unable to load event types");
    }
  }
  async function onSubmit(values) {
    setLoading(true);
    try {
      let eventType = values.eventType;
      if (values.filterBy === "stepcompleted") {
        eventType = "bank_account_verified";
      }
      let eventDetails = await getList(
        "events",
        activeCompany,
        {
          filterBy: values.filterBy,
          startDate: moment
            .utc(values.startDate, Constants.DATEFORMAT.MMDDYYYY)
            .startOf("day")
            .valueOf(),
          endDate: moment
            .utc(values.endDate, Constants.DATEFORMAT.MMDDYYYY)
            .endOf("day")
            .valueOf(),
          eventType,
        },
        "events-api"
      );
      if (eventDetails && eventDetails.results) {
        let updated = [];
        for (let event of eventDetails.results) {
          let updatedEvent = {
            ...event,
            lastUpdateTime: formatDate(
              event.lastUpdateTime,
              Constants.DATEFORMAT.MMDDYYYYHH
            ),
            userCreateTime: event.userCreateTime
              ? formatDate(
                  event.userCreateTime,
                  Constants.DATEFORMAT.MMDDYYYYHH
                )
              : null,
            displayName: event?.eventType?.displayName,
          };
          if (updatedEvent?.info?.payStubFile) {
            const filecomp = (
              <ViewFileURL fileName={updatedEvent?.info?.payStubFile} />
            );
            updatedEvent.info.payStubFile = filecomp;
          }
          updated.push(updatedEvent);
        }
        setEvents(updated);
      } else {
        setEvents([]);
      }
    } catch (e) {
      console.log("error", e);
      toast.error("Unable to get events");
    }
    setLoading(false);
  }
  return (
    <LoggedInLayout title="Signup Customer Events">
      <PageLoader isActive={loading}>
        <Row>
          <Col sm={4}>
            <Formik
              validationSchema={schema}
              onSubmit={onSubmit}
              initialValues={initialValues}
              validateOnMount
            >
              {({ isValid, isSubmitting, values, setFieldValue }) => (
                <Form className="w-100">
                  <div>
                    <FormikDropdown
                      name="filterBy"
                      label="Filter Event By"
                      options={[
                        {
                          value: "date",
                          name: "Filter by Date Range",
                        },
                        {
                          value: "type",
                          name: "Filter by Step Not Completed",
                        },
                        {
                          value: "stepcompleted",
                          name: "Filter by ALL Steps Completed",
                        },
                      ]}
                    />
                    {(values.filterBy === "date" ||
                      values.filterBy === "stepcompleted") && (
                      <>
                        <FormikDateField
                          name="startDate"
                          label="Start Date"
                          size={"sm"}
                          controlId="startDate"
                        />
                        <FormikDateField
                          name="endDate"
                          label="End Date"
                          controlId="endDate"
                          size={"sm"}
                        />
                      </>
                    )}
                    {values.filterBy === "type" && (
                      <FormikDropdown
                        name="eventType"
                        label="Select Step"
                        options={[...eventTypes].splice(1)}
                        placeholder="Select Step"
                      />
                    )}
                    <LoaderButton
                      block
                      type="submit"
                      variant="primary"
                      text="Next"
                      className="mb-2"
                      isLoading={isSubmitting}
                      disabled={!isValid || isSubmitting}
                    >
                      Search
                    </LoaderButton>
                  </div>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
        <div className="mt-2 mb-2 ms-1 d-flex justify-content-end">
          <ExportEvents events={events} />
        </div>
        <Events events={events} />
      </PageLoader>
    </LoggedInLayout>
  );
};

export default SignupEvents;
